import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';

function AdminAPVerification({ playerId }) {
  const [pendingRecords, setPendingRecords] = useState([]);
  const [message, setMessage] = useState('');
  const [pointsInput, setPointsInput] = useState({});
  const [qsInput, setQsInput] = useState({});

  useEffect(() => {
    if (!playerId) return;
    const fetchPendingRecords = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/admin/pending-records?adminId=${playerId}`, {
          headers: { 'Content-Type': 'application/json' }
        });
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        setPendingRecords(data);
        const initialPoints = {};
        const initialQs = {};
        data.forEach(record => {
          initialPoints[record._id] = record.awardPoints || 0;
          initialQs[record._id] = record.qualifyingScore || false;
        });
        setPointsInput(initialPoints);
        setQsInput(initialQs);
      } catch (error) {
        setMessage('Error fetching pending records: ' + error.message);
      }
    };
    fetchPendingRecords();
  }, [playerId]);

  const handlePointsChange = (recordId, value) => {
    setPointsInput(prev => ({ ...prev, [recordId]: parseInt(value) || 0 }));
  };

  const handleQsChange = (recordId, value) => {
    setQsInput(prev => ({ ...prev, [recordId]: value }));
  };

  const validateRecord = async (dogId, recordId, type) => {
    try {
      const awardPoints = pointsInput[recordId] || 0;
      const qualifyingScore = type === 'sporting' ? qsInput[recordId] : undefined;
      const endpoint = type === 'conformation' ? 'validate-show-record' : 'validate-sporting-record';
      const res = await fetch(`${API_BASE_URL}/admin/${endpoint}/${dogId}/${recordId}?adminId=${playerId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ validated: true, awardPoints, qualifyingScore })
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setMessage(data.message);
      setPendingRecords(pendingRecords.filter(r => r._id !== recordId));
    } catch (error) {
      setMessage('Error validating record: ' + error.message);
    }
  };

  const rejectRecord = async (dogId, recordId, type) => {
    try {
      const endpoint = type === 'conformation' ? 'validate-show-record' : 'validate-sporting-record';
      const res = await fetch(`${API_BASE_URL}/admin/${endpoint}/${dogId}/${recordId}?adminId=${playerId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ validated: false, remove: true })
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setMessage(data.message);
      setPendingRecords(pendingRecords.filter(r => r._id !== recordId));
    } catch (error) {
      setMessage('Error rejecting record: ' + error.message);
    }
  };

  if (!playerId) return <p style={{ textAlign: 'center', color: '#333' }}>Please log in as an admin.</p>;

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <h1 style={{ textAlign: 'center', color: '#333', marginBottom: '20px' }}>Record Verification</h1>
      {message && <p style={{ textAlign: 'center', color: message.includes('Error') ? '#FF4444' : '#4CAF50' }}>{message}</p>}
      <h2 style={{ color: '#4CAF50', marginBottom: '15px' }}>Pending Records</h2>
      {pendingRecords.length > 0 ? (
        pendingRecords.map(record => (
          <div key={record._id} style={{ marginBottom: '20px', padding: '15px', background: '#f9f9f9', borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
            <p><strong>Type:</strong> {record.type === 'conformation' ? 'Conformation' : 'Sporting'}</p>
            <p><strong>Dog:</strong> {record.dog.registeredName} ({record.dog.dogId})</p>
            <p><strong>Show Name:</strong> {record.showName}</p>
            <p><strong>Result:</strong> {record.result}</p>
            {record.resultUrl && <p><strong>Result URL:</strong> <a href={record.resultUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50' }}>{record.resultUrl}</a></p>}
            {record.artworkLink && <p><strong>Artwork:</strong> <a href={record.artworkLink} target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50' }}>{record.artworkLink}</a></p>}
            {record.iconUrl && record.iconUrl.length > 0 && (
              <p><strong>Ribbons:</strong> {record.iconUrl.map((url, i) => (
                <img key={i} src={url} alt="Ribbon" style={{ width: '100px', height: 'auto', marginRight: '5px' }} />
              ))}</p>
            )}
            <p><strong>Suggested Points:</strong> {record.awardPoints || 0}</p>
            {record.type === 'sporting' && (
              <p><strong>Suggested QS:</strong> {record.qualifyingScore ? 'Yes' : 'No'}</p>
            )}
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', flexWrap: 'wrap', gap: '10px' }}>
              <input
                type="number"
                min="0"
                value={pointsInput[record._id] || ''}
                onChange={e => handlePointsChange(record._id, e.target.value)}
                placeholder="Award Points"
                style={{ padding: '5px', width: '100px', border: '1px solid #ccc', borderRadius: '3px' }}
              />
              {record.type === 'sporting' && (
                <label style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    checked={qsInput[record._id] || false}
                    onChange={e => handleQsChange(record._id, e.target.checked)}
                    style={{ marginRight: '5px' }}
                  />
                  QS
                </label>
              )}
              <button onClick={() => validateRecord(record.dog.dogId, record._id, record.type)} style={{ background: '#4CAF50', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '3px', marginRight: '10px' }}>Approve</button>
              <button onClick={() => rejectRecord(record.dog.dogId, record._id, record.type)} style={{ background: '#FF69B4', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '3px' }}>Reject</button>
            </div>
          </div>
        ))
      ) : <p style={{ textAlign: 'center', color: '#888' }}>No pending records to validate.</p>}
    </div>
  );
}

export default AdminAPVerification;